module.exports = __webpack_public_path__ + "static/logo-c699e3bd1e488b831f3c481c2bf053f1.svg";